import Swiper from 'swiper/bundle';

// import styles bundle
import 'swiper/css/bundle';

export const featuredPosts = () => {


  const el = document.querySelector('.featured-posts--grid');
  const swiper = new Swiper( el, {
        autoHeight: false,
        slidesPerView: 1,
        slidesPerGroup: 1,
        spaceBetween: 30,
        // grid: {
        //   column: 4,
        // },
        // effect: 'fade',
        // fadeEffect: {
        //   crossFade: true
        // },
        // direction: 'vertical',
        // loop: true,
        breakpoints: {
          200: {
            slidesPerView: 1,
            //slidesPerGroup: 1,
          },
          768: {
            slidesPerView: 2,
            //slidesPerGroup: 2,
          },
          1024: {
            slidesPerView: 3,
            //slidesPerGroup: 3,
          },
          1200: {
            slidesPerView: 4,
            //slidesPerGroup: 4,
          },
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },

      });

}
